import React from 'react';
import { object, string, ref } from 'yup';
import {
  Formik,
  Form,
} from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';

import { useHttpStatus } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const schema = object().shape({
  password: string()
    .min(7)
    .required(),
  passwordConfirm: string()
    .oneOf(
      [ref('password')],
      'Both passwords need to be the same',
    )
    .required(),
});
const defaults = {
  password: '',
  passwordConfirm: '',
};

const FormPwdReset = ({ resetKey }) => {
  const [res, req] = useHttpStatus();

  return (
    <>
      {res.status === 'success' ? (
        <div>
          <h2>
            <FA icon={faCheckCircle} />
            &nbsp;
            Success.
          </h2>
          <p>
            你已成功更改密碼
            <br />
            <a href="/">
              重返登入頁
            </a>
          </p>
        </div>
      ) : (
        <Formik
          validationSchema={schema}
          initialValues={defaults}
          validateOnMount={true}
          onSubmit={({ password }) => req({
            method: 'post',
            url: '/api/core/password/reset',
            data: { password, key: resetKey },
          })}
        >
          <Form>
            <FormHttpAlert res={res} />
            <h2>Password reset</h2>
            <FormGroup
              name="password"
              type="password"
              label="New password"
              placeholder="At least 7 characters long"
              affirm
            />
            <FormGroup
              name="passwordConfirm"
              type="password"
              label="Re-enter new password"
              affirm
            />
            <div className="form-group text-right">
              <FormHttpBtn
                res={res}
                type="submit"
                className="btn-block btn-primary"
                icon={faSave}
              >
                重設密碼
              </FormHttpBtn>
            </div>
          </Form>
        </Formik>
      )}
    </>
  );
};

export default FormPwdReset;
